import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Clients } from "@/components/site/Clients";
import { About } from "@/components/site/About";
import { Capabilities } from "@/components/site/Capabilities";
import { Process } from "@/components/site/Process";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="relative bg-[color:var(--ivory)] text-[color:var(--ink)]"
    >
      <Header />
      <Hero />
      <Clients />
      <About />
      <Capabilities />
      <Process />
      <Contact />
      <Footer />
    </main>
  );
}
